import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApplicationData, ApplyState } from 'src/types/flow';

const INITIAL_STATE: ApplyState = {
  applicationLoading: false, // Indicates if the application process, after confirmation, has started.
  applicationError: '',
  applicationFinished: false,
  applicationData: {},
  applicationNumber: '',
};

export const applySlice = createSlice({
  name: 'apply',
  initialState: INITIAL_STATE,
  reducers: {
    startApplication: (state, action: PayloadAction<ApplicationData>) => {
      state.applicationLoading = true;
      state.applicationData = { ...action.payload, ...state.applicationData };
    },
    setApplicationError: (state, action: PayloadAction<string>) => {
      state.applicationLoading = false;
      state.applicationError = action.payload;
      state.applicationFinished = false;
    },
    finishApplication: (state) => {
      state.applicationFinished = true;
    },
    setApplicationLoading: (state, action: PayloadAction<boolean>) => {
      state.applicationLoading = action.payload;
    },
    clearApplication(state) {
      state.applicationError = '';
      state.applicationFinished = false;
      state.applicationLoading = false;
      state.applicationNumber = '';
    },
    updatePermitApplicationData: (state, action) => {
      state.applicationData = {
        ...state.applicationData,
        ...action.payload,
      };
    },
    removeRegistrantData: (state) => {
      if (state.applicationData) delete state.applicationData.registrant;
    },
    removeContactsData: (state) => {
      if (state.applicationData) delete state.applicationData.contacts;
    },
    removePropertyDetailsData: (state) => {
      if (state.applicationData) delete state.applicationData.propertyDetails;
    },
    removeListingsData: (state) => {
      if (state.applicationData) delete state.applicationData.listings;
    },
    clearAllDataExceptProperty: (state) => {
      const property = state.applicationData?.property;
      state.applicationData = { property };
    },
    setApplyApplicationNumber: (state, action) => {
      state.applicationNumber = action.payload;
    },
    resetApplyState: () => INITIAL_STATE,
  },
});

export const {
  updatePermitApplicationData,
  removeRegistrantData,
  removeContactsData,
  removeListingsData,
  removePropertyDetailsData,
  clearAllDataExceptProperty,
  setApplicationLoading,
  finishApplication,
  setApplyApplicationNumber,
  setApplicationError,
  startApplication,
  clearApplication,
  resetApplyState,
} = applySlice.actions;

export default applySlice.reducer;
